import React, { createContext, useContext, ReactNode } from 'react';

/**
 * Context that provides the user's preferred language.
 *
 * This is calculated from identity data or user preferences and represents
 * the language the user wants to see, regardless of whether the locale chunk
 * has loaded yet.
 */
interface LanguagePreferenceContextValue {
  preferredLanguage: string | null;
  isLanguageReady: boolean;
}

const LanguagePreferenceContext = createContext<LanguagePreferenceContextValue>(
  {
    preferredLanguage: null,
    isLanguageReady: false,
  },
);

interface LanguagePreferenceProviderProps {
  children: ReactNode;
  preferredLanguage: string | null;
  isLanguageReady: boolean;
}

export const LanguagePreferenceProvider: React.FC<
  LanguagePreferenceProviderProps
> = ({ children, preferredLanguage, isLanguageReady }) => {
  return (
    <LanguagePreferenceContext.Provider
      value={{ preferredLanguage, isLanguageReady }}
    >
      {children}
    </LanguagePreferenceContext.Provider>
  );
};

export const useLanguagePreference = () =>
  useContext(LanguagePreferenceContext);
